import { BaseFixedModel } from './base.model';

export class LastUpdatedModel extends BaseFixedModel {
}
